import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { formulas } from '../../data/site';
export function FormulasSection() {
  const [main, second] = formulas;
  return <section className="bg-ink py-24 md:py-36" data-id="element-77" data-mp="3m4ib6i6fi3ag">
      <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-78" data-mp="3hbfew2a9ofqk">
        <Reveal data-id="element-79" data-mp="3h9ul4evs10tr">
          <h2 className="font-display text-5xl uppercase leading-none md:text-7xl" data-id="element-80" data-mp="3w0lfnuor6e0k">Deux spectacles</h2>
          <p className="mt-4 max-w-lg text-paper/60" data-id="element-81" data-mp="3r1qvaob50hec">
            Choisissez l’histoire que vous voulez raconter à votre public.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-5 lg:grid-cols-[1.6fr_1fr]" data-id="element-82" data-mp="8v2qz0nwvy9q">
          <Reveal data-id="element-83" data-mp="4vbvwkrcqvze">
            <Link to="/formules" className="group flex h-full flex-col rounded-2xl bg-signal p-8 transition-transform duration-200 ease-out hover:-translate-y-1 md:p-12" data-id="element-84" data-mp="4usa2sykzng3">
              <p className="text-sm font-medium text-paper/80" data-id="element-85" data-mp="26ngkpndk1d5w">{main.tagline}</p>
              <h3 className="mt-3 font-display text-5xl uppercase leading-none md:text-7xl" data-id="element-86" data-mp="33f9f6gg34cn5">{main.name}</h3>
              <p className="mt-6 max-w-xl text-lg leading-relaxed text-paper/90" data-id="element-87" data-mp="38d15j612zqp8">{main.description}</p>
              <ul className="mt-8 flex flex-wrap gap-2" data-id="element-88" data-mp="3dajir8m4ss31">
                {main.details.map(d => <li key={d} className="rounded-full border border-paper/40 px-4 py-1.5 text-sm" data-id="element-89" data-mp="3i3vvolhg7afy">
                    {d}
                  </li>)}
              </ul>
              <span className="mt-auto inline-flex items-center gap-2 pt-10 font-semibold" data-id="element-90" data-mp="3r1o8nizp6606">
                Découvrir le show
                <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 group-hover:translate-x-1" data-id="element-91" data-mp="3w09dxwtt3fvh" />
              </span>
            </Link>
          </Reveal>

          <Reveal delay={0.06} data-id="element-92" data-mp="21pvvrailrksp">
            <Link to="/formules" className="group flex h-full flex-col rounded-2xl border border-paper/15 bg-coal p-8 transition-[transform,border-color] duration-200 ease-out hover:-translate-y-1 hover:border-paper/40 md:p-10" data-id="element-93" data-mp="21qntaqvrfslm">
              <p className="text-sm font-medium text-paper/60" data-id="element-94" data-mp="1umpdqmvcv6kv">{second.tagline}</p>
              <h3 className="mt-3 font-display text-4xl uppercase leading-none md:text-5xl" data-id="element-95" data-mp="28lp1lsb1nhfz">{second.name}</h3>
              <p className="mt-6 leading-relaxed text-paper/70" data-id="element-96" data-mp="23k82a187k31i">{second.description}</p>
              <ul className="mt-6 space-y-1 text-sm text-paper/60" data-id="element-97" data-mp="2hk9eudxu4ywt">
                {second.details.map(d => <li key={d} data-id="element-98" data-mp="2djh1b8hxk7uq">— {d}</li>)}
              </ul>
              <span className="mt-auto inline-flex items-center gap-2 pt-10 font-semibold" data-id="element-99" data-mp="2rac5w8lec2si">
                En savoir plus
                <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 group-hover:translate-x-1" data-id="element-100" data-mp="2md2j70pe658d" />
              </span>
            </Link>
          </Reveal>
        </div>
      </div>
    </section>;
}